import {useFetch} from "../useFetch";
import {vehicleService} from "../../services/guide/vehicle-service";
import {VehicleById} from "../../types/api/guide/vehicle.types";

export const useFetchGetVehicleById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<VehicleById>(
            vehicleService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as VehicleById, isLoading, error };
}